import { Redirect, Route } from "react-router-dom";
import React, { useState, useEffect } from "react";
import AuthClient from "../api";

const PrivateRouteComp = ({ component: Component, ...rest }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("userId");
    localStorage.removeItem("email");
  };

  useEffect(() => {
    const checkAuthentication = async () => {
      try {
        const response = await AuthClient.get('/me');
        if (response.status === 200) {
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
          logout();
        }
      } catch (error) {
        setIsAuthenticated(false);
        logout();
      }
    };

    checkAuthentication();
  }, [ ]);

  if (isAuthenticated === null) {
    return null;
  }

  return (
    <>
      <Route {...rest}>
        {isAuthenticated ? (
          <Component />
        ) : (
          <Redirect
            to={{
              pathname: '/login',
            }}
          />
        )}
      </Route>
    </>
  );
};;
export const PrivateRoute = React.memo(PrivateRouteComp);
export default PrivateRoute;
